import * as z from "zod";

export const getSupportInsightMetaConnections = {
  name: "getSupportInsightMetaConnections" as const,
  input: z.null(),
  output: z.object({ facebook: z.boolean(), instagram: z.boolean() }),
};
